// extracted by mini-css-extract-plugin
module.exports = {"chatContainer":"index-module__chatContainer___3Ej79","chatTable":"index-module__chatTable___27mCD"};